var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[(_vm.isLogin)?_c('CoreNavigation',{ref:"CoreNavigationRef"}):_vm._e(),_c('CoreView'),_c('MsgBar',{ref:"MsgBarRef"}),_c('MsgBox',{ref:"MsgBoxRef"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }